<template>
  <div class="modal-container">
    <!--pop-header//-->
    <ul class="pop-header-nav">
      <li>
        <button type="button" @click="setTabPage('broadcast')" :class="pageType === 'broadcast' ? 'pop-header-nav-on' : ''">
          시리즈
        </button>
      </li>
      <li v-if="isplayymovie === 'y'">
        <button type="button" @click="setTabPage('movie')" :class="pageType === 'movie' ? 'pop-header-nav-on' : ''">
          영화
        </button>
      </li>
    </ul>
    <!--pop-header//-->
    <!--pop-body//-->
    <div class="sh-pop-body" ref="tagList">
      <template v-for="(data, index) in tagList.taggrouptitlelist">
        <div class="popup-tag-wrap" :key="`outer${index}`">
          <h2 class="hashtag-tit" tabindex="0">{{data.title}}</h2>
          <template v-for="(subData, index2) in data.tagsubgrouplist">
            <h3 v-if="subData.title" class="hashtag-sub-tit" :key="`inner1${index2}`" tabindex="0">
              <img
                v-if="subData.iconimage"
                :src="getImageIcon(subData.iconimage)"
                :alt="`${subData.title} 아이콘`"
              >
              {{subData.title}}
            </h3>
            <ul class="search-tag-list" :key="index2">
              <li v-for="(tag, index3) in subData.list" :key="`tag${index3}`">
                <input
                  type="checkbox"
                  :id="`tag${index}${index2}${index3}`"
                  @change="setTagSelect($event, tag.taggroup, tag.text, tag.value)" v-model="tagData"
                  :value="tag.taggroup + '|' + tag.text + '|' + tag.value"
                >
                <label :for="`tag${index}${index2}${index3}`">{{tag.text}}</label>
              </li>
            </ul>
          </template>
        </div>
      </template>
    </div>
    <!--pop-body//-->

    <!--pop-footer//-->
    <div class="sh-pop-footer">
      <div class="popup-bt-btn">
        <ul>
          <li><button @click="setInitSelect()" class="pop-btn-gray">선택 초기화</button></li>
          <li><button @click="tagSearch()" class="pop-btn-purple">검색</button></li>
        </ul>
      </div>
    </div>
    <!--pop-footer//-->
  </div>
</template>

<script>
import { getTagsGroups } from '@/common/utils/request'
import { CLOSE_SEARCH_POPUP_EVENT } from '@/common/resources/const'
import cookie from '@/common/utils/cookie'
import { PATH_NAME_SEARCH_TAG } from '@/common/resources/router.const'
import { sendEventLogTagSearch } from '@/common/utils/log.v2.send'
import { stringify } from 'query-string'
import { getTimeStamp } from '@/common/utils/common'
import { resizeThumbnail } from '@/common/utils/image'
export default {
  props: {
    // 태그검색:tagDetail, 태그 재검색:reTagDetail
    statusView: {
      type: String
    },
    searchPageType: {
      type: String
    },
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  data () {
    return {
      pageType: 'broadcast', // broadcast: 방송, movie: 영화
      paramCheck: false, // 처음 화면 로딩시 Local Storage에 저장된 태그값 출력여부(true:출력, false:미출력)
      tagData: [], // checkBox 선택 데이터
      vodTagList: [],
      movieTagList: [],
      vodTagData: [], // 방송 checkBox 선택 데이터
      movieTagData: [], // 영화 checkBox 선택 데이터
      tagLocalData: [], // localStorage 저장 tag 데이터
      vodLocalData: [], // 방송 localStorage 저장 tag 데이터
      movieLocalData: [], // 영화 localStorage 저장 tag 데이터
      tagList: [],
      pooqzoneType: cookie.getPooqZoneType()
    }
  },
  computed: {
    setBtnDisable () {
      return this.tagData.length === 0 ? 'search-btn-fixed search-disable' : 'search-btn-fixed'
    }
  },
  methods: {
    getImageIcon (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: 20, quality: 80 })
    },
    scrollTop () {
      this.$refs.tagList.scrollTop = 0
    },
    // 방송, 영화 탭에 따른 설정
    setTabPage (type) {
      // this.scrollTop()
      this.pageType = type
      if (type === 'broadcast') {
        this.tagData = this.vodTagData
        this.tagLocalData = this.vodLocalData
      } else {
        this.tagData = this.movieTagData
        this.tagLocalData = this.movieLocalData
      }
      this.getTagList(type)
    },
    // 선택 초기화
    setInitSelect () {
      if (this.tagData.length > 0) {
        this.tagData = []
        this.tagLocalData = []

        if (this.pageType === 'broadcast') {
          this.vodTagData = []
          this.vodLocalData = []
        } else {
          this.movieTagData = []
          this.movieLocalData = []
        }
      }
    },
    // 태그 선택
    setTagSelect (event, tempTaggroup, tempText, tempValue) {
      let tagIndex = 0
      let strTag = tempTaggroup + '|' + tempText + '|' + tempValue
      if (event.target.checked) {
        // 선택 시
        this.tagLocalData.push(strTag)
      } else {
        // 선택 해제 시
        tagIndex = this.tagLocalData.indexOf(strTag)
        if (tagIndex >= 0) {
          this.tagLocalData.splice(tagIndex, 1)
        }
      }
      if (this.pageType === 'broadcast') {
        this.vodTagData = this.tagData
        this.vodLocalData = this.tagLocalData
      } else {
        this.movieTagData = this.tagData
        this.movieLocalData = this.tagLocalData
      }
    },
    // 검색
    tagSearch () {
      const routeObj = { name: PATH_NAME_SEARCH_TAG, query: { category: 'all', page: '1', timestamp: getTimeStamp() } }
      if (this.tagData.length > 0) {
        if (this.tagData && this.tagLocalData && this.tagData.length === this.tagLocalData.length) {
          localStorage.removeItem('search-broadcast')
          localStorage.removeItem('search-movie')
          if (this.pageType === 'broadcast') {
            localStorage.setItem('search-broadcast', this.tagLocalData.join('&'))
            localStorage.setItem('search-type', 'broadcast')
          } else {
            localStorage.setItem('search-movie', this.tagLocalData.join('&'))
            localStorage.setItem('search-type', 'movie')
          }
          this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
          this.$events.$emit('tag-search')
          sendEventLogTagSearch({ type: this.pageType, tagDataList: this.tagData, landingUrl: `${routeObj?.name}${stringify(routeObj?.query)}` })
          this.$router.push(routeObj).catch(() => {})
        }
      } else {
        alert('태그를 선택하세요.')
      }
    },
    getTagList (type) {
      if (type === 'broadcast') {
        this.tagList = this.vodTagList
      } else {
        this.tagList = this.movieTagList
      }
    }
  },
  created () {
    let strTagList = ''

    // 태그 재검색 시 statusView
    if (this.searchPageType === 'reTagDetail_broadcast' || this.searchPageType === 'reTagDetail_movie') {
      if (this.searchPageType === 'reTagDetail_broadcast') {
        this.pageType = 'broadcast'
      } else {
        this.pageType = 'movie'
      }

      this.tagData = []
      this.vodTagData = []
      this.movieTagData = []

      this.tagLocalData = []
      this.vodLocalData = []
      this.movieLocalData = []

      if (this.pageType === 'broadcast') {
        strTagList = localStorage.getItem('search-broadcast')
      } else {
        strTagList = localStorage.getItem('search-movie')
      }

      if (strTagList && strTagList !== 'none') {
        this.tagLocalData = strTagList.split('&')
        this.tagData = this.tagLocalData.map((tagData) => {
          return tagData
        })

        if (this.pageType === 'broadcast') {
          this.vodTagData = this.tagData
          this.vodLocalData = this.tagLocalData
        } else {
          this.movieTagData = this.tagData
          this.movieLocalData = this.tagLocalData
        }
      }
    } else {
      this.pageType = this.searchPageType
    }

    // 태그 리스트 조회
    getTagsGroups({ type: 'vodsearch_dark' }).then((response) => {
      this.vodTagList = response.data
      this.tagList = this.pageType === 'movie' ? this.movieTagList : this.vodTagList
    })
    getTagsGroups({ type: 'moviesearch' }).then((response) => {
      this.movieTagList = response.data
      this.tagList = this.pageType === 'movie' ? this.movieTagList : this.vodTagList
    })
  }
}
</script>

<style lang="css">
.pop-header-btn{
  background: url(~@/assets/images/search/search-icon-layer-input-26.png) no-repeat left/22px;
}
</style>
